import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Cancel() {
  const navigate = useNavigate();

  useEffect(() => {
    const cleanup = () => {
      sessionStorage.removeItem('pendingOrder');
      toast.error('Zahlung wurde abgebrochen');
      setTimeout(() => navigate('/'), 3000);
    };

    cleanup();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <h2 className="text-2xl font-bold text-red-500 mb-4">Zahlung abgebrochen</h2>
        <p className="mb-6">Sie werden zur Startseite weitergeleitet...</p>
        <ToastContainer position="bottom-right" />
      </div>
    </div>
  );
}

export default Cancel;